import { DataPsmAssociationEnd, DataPsmInclude, DataPsmOr } from "../model/index.js";
/**
 * Todo introduce as operation
 */
export async function replaceObjectInSchema(schemaIri, searchIri, replacementIri, reader) {
    const schema = await reader.readResource(schemaIri);
    const changedResources = [];
    // Check roots
    if (schema.dataPsmRoots.includes(searchIri)) {
        changedResources.push({ ...schema, dataPsmRoots: [...schema.dataPsmRoots.map((iri) => (iri === searchIri ? replacementIri : iri))] });
    }
    // Check all resources in schema
    for (const resourceIri of schema.dataPsmParts) {
        const resource = await reader.readResource(resourceIri);
        if (resource === null) {
            continue;
        }
        // Check associations
        if (DataPsmAssociationEnd.is(resource)) {
            if (resource.dataPsmPart === searchIri) {
                changedResources.push({ ...resource, dataPsmPart: replacementIri });
            }
        }
        // Check ors
        if (DataPsmOr.is(resource)) {
            if (resource.dataPsmChoices.includes(searchIri)) {
                changedResources.push({ ...resource, dataPsmChoices: resource.dataPsmChoices.map((iri) => (iri === searchIri ? replacementIri : iri)) });
            }
        }
        // Check includes
        if (DataPsmInclude.is(resource)) {
            if (resource.dataPsmIncludes === searchIri) {
                changedResources.push({ ...resource, dataPsmIncludes: replacementIri });
            }
        }
    }
    return changedResources;
}
//# sourceMappingURL=replace-object-in-schema.js.map